"use client";

import { c as _c } from "react/compiler-runtime";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ThemeProvider } from "next-themes";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import { useEffect, useState } from "react";
import { Toaster } from "@/components/ui/sonner";
import { AppConfigProvider } from "@/lib/config";
import { flushPendingIdentity } from "@/lib/posthog-identity";
import { ProviderMarksProvider } from "@llmgateway/shared/components";
import type { AppConfig } from "@/lib/config-server";
import type { ReactNode } from "react";
interface ProvidersProps {
  children: ReactNode;
  config: AppConfig;
}
export function Providers(t0) {
  const $ = _c(17);
  const {
    children,
    config
  } = t0;
  const [queryClient] = useState(_temp);
  let t1;
  let t2;
  if ($[0] !== config.posthogHost || $[1] !== config.posthogKey) {
    t1 = () => {
      if (!config.posthogKey) {
        return;
      }
      const key = config.posthogKey;
      const host = config.posthogHost;
      const init = () => {
        posthog.init(key, {
          api_host: "/ingest",
          ui_host: host,
          capture_pageview: "history_change",
          autocapture: true,
          disable_surveys: true,
          loaded: flushPendingIdentity
        });
      };
      if (typeof requestIdleCallback !== "undefined") {
        const id = requestIdleCallback(init, {
          timeout: 800
        });
        return () => cancelIdleCallback(id);
      }
      const timer = setTimeout(init, 300);
      return () => clearTimeout(timer);
    };
    t2 = [config.posthogKey, config.posthogHost];
    $[0] = config.posthogHost;
    $[1] = config.posthogKey;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== children || $[5] !== config.apiUrl) {
    t3 = <PostHogProvider client={posthog}><ProviderMarksProvider apiUrl={config.apiUrl}>{children}</ProviderMarksProvider></PostHogProvider>;
    $[4] = children;
    $[5] = config.apiUrl;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = process.env.NODE_ENV === "development" && <ReactQueryDevtools buttonPosition="top-right" />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== queryClient || $[9] !== t3) {
    t5 = <QueryClientProvider client={queryClient}>{t3}{t4}</QueryClientProvider>;
    $[8] = queryClient;
    $[9] = t3;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Toaster />;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5) {
    t7 = <ThemeProvider attribute="class" defaultTheme="system" enableSystem={true} storageKey="theme">{t5}{t6}</ThemeProvider>;
    $[12] = t5;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== config || $[15] !== t7) {
    t8 = <AppConfigProvider config={config}>{t7}</AppConfigProvider>;
    $[14] = config;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}
function _temp() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        staleTime: 300000,
        retry: false
      }
    }
  });
}